export default __webpack_public_path__ + "static/media/GTWalsheimPro-Regular.6aff6f11.woff2";